export default "__VITE_ASSET__4472424f__"